// extracted by css-extract-rspack-plugin
export default {"root":"root-_mLl_E"};